import React from 'react';
import { RadioStatesProps } from './model/RadioStatesProps.interface';

import cls from './RadioBtn.module.css';

export function UncheckedRadio({ onClick, fill = '#252733' }: RadioStatesProps) {
    return (
        <span className={cls.icon}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                onClick={onClick}
            >
                <g opacity="0.7" clipPath="url(#clip0_5222_971)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.99998 2C5.90898 2 1.99997 5.91045 1.99997 10.0014C1.99997 14.0924 5.90898 18 9.99998 18C14.091 18 18 14.0924 18 10.0014C18 5.91045 14.091 2 9.99998 2ZM0.740723 10.0014C0.740723 4.8877 4.88623 0.742188 9.99998 0.742188C15.1137 0.742188 19.2592 4.8877 19.2592 10.0014C19.2592 15.1152 15.1137 19.2607 9.99998 19.2607C4.88623 19.2607 0.740723 15.1152 0.740723 10.0014Z"
                        fill={fill}
                    />
                    <path
                        className={cls.iconUncheck}
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.3841 7C14.7599 7.34685 14.731 7.47595 14.3841 7.85171L9.25594 13.4073C9.08066 13.5972 8.83399 13.7052 8.57557 13.7052C8.31714 13.7052 8.07048 13.5972 7.89519 13.4073L5.61599 10.9381C5.26914 10.5624 5.24036 10.3469 5.61612 10C5.99188 9.65316 6.15322 9.62425 6.50007 10L8.57557 12L11.0002 9.50001L13.5 7.00001C13.8469 6.62425 14.0084 6.65314 14.3841 7Z"
                        fill="#252733"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_5222_971">
                        <rect width="20" height="20" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </span>
    );
}
